import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

export default class MwSelect extends Component {

  @tracked selectedOption = 'Option 1';
  @tracked options = {
    'Option 1': 'Option 1',
    'Option 2': 'Option 2',
    'Option 3': 'Option 3',
    'Option 4': 'Option 4',
    'Option 5': 'Option 5',
    'Option 6': 'Option 6',
    'Option 7': 'Option 7',
  };
  @tracked searchValue;
  @tracked searchedItems;
  
  @action
  setSelectedOption(option) {
    this.selectedOption = option;
  }

  @action
  setGroupSearchValue(searchValue) {
    this.searchValue = searchValue;
  }

  @action
  setGroupSearchedItems(searchedItems) {
    this.searchedItems = searchedItems;
  }
}
